import React, {useEffect} from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import Styles from './styles.module.scss'
import {useDispatch, useSelector} from "react-redux";

import {getReferralAwards, setReferralModalStatus} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";



const CabinetReferralModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const referralModalStatus = useSelector(store => store.cabinet.referralModalStatus);
    const referralAwards = useSelector(store => store.cabinet.referralAwards);



    const closeModal = () =>{
        dispatch(setReferralModalStatus(false));
    }

    useEffect(() => {
        if (referralModalStatus){
            dispatch(getReferralAwards());
        }
    }, [dispatch, referralModalStatus]);

    return (
        <DsModal
            open={referralModalStatus}
            onClose={closeModal}
            size="lg"
            title={t('Реферальная программа')}
        >
            <div className={Form.noteMuted}>{t('Реферальная программа позволяет получать бонусы за активное участие и приглашение новых пользователей. С каждого круга выделяется часть прибыли на вознаграждения: топ-20 участников получают повышенные проценты, остальные — согласно таблице распределения. Кроме того, всем участникам начисляется дополнительная возможность купить больше токенов. За каждого приглашённого, который приобрёл хотя бы один токен, вы получаете право купить ещё +3 токена на следующем круге.')}</div>
            <div className={Styles.table}>
                <div className={`${Styles.row} ${Styles.head}`}>
                    <span>{t('Места')}</span>
                    <span>{t('Вознаграждение')}</span>
                    <span>{t('Бонусные токены')}</span>
                </div>
                <div className={Styles.rows}>
                    {referralAwards?.awards?.length > 0 ? referralAwards.awards.map((item, index) => (
                        <div className={`${Styles.row} ${index < 3 ? Styles.top : ''}`} key={'referralReward' + index}>
                            <span>{item.place}</span>
                            <span>{item.award_percent * 1}%</span>
                            <span>+{item.additional_token_purchase_count * 1} {t('токенов')}</span>
                        </div>
                    )) : <div className={Styles.empty}>{t('Загрузка...')}</div>}
                </div>
            </div>
        </DsModal>
    );
};

export default CabinetReferralModal;
